import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";

export default function ChangeProfile(props) {
  const { lang, proxy, functions } = useSelector((state) => state);
  const _token = localStorage.getItem("_token");
  const {
    profile: { username, fullname, phone, address, note, avatar, email },
    fileInputRef,
    handleClick,
    handleFileUpload,
    isAvatar,
    timestamp,
  } = props;
  const { replaceString } = functions;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username,
      fullname,
      phone,
      email,
      address,
      note,
      avatar,
    },
  });

  const onSubmit = (data) => {
    const requestBody = {
      account: {
        ...data,
      },
    };
    fetch(`${proxy()}/auth/self/info`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
        Authorization: `${_token}`,
      },
      body: JSON.stringify(requestBody),
    })
      .then((res) => res.json())
      .then((resp) => {
        const { success, content, status } = resp;
        Swal.fire({
          title: success ? lang["success"] : lang["error"],
          text: content,
          icon: success ? "success" : "error",
          showConfirmButton: !success && true,
          timer: success && 1500,
        });
        // reset();
      });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="row">
      <div className="profile_img m-0 col-lg-10 col-xs-12 text-center">
        <div
          style={{
            width: "96px",
            height: "96px",
          }}
        >
          <img
            className="rounded-circle pointer w-100 h-100"
            width="80"
            src={isAvatar ? isAvatar : `${proxy() + avatar}`}
            onClick={handleClick}
            alt="Profile"
            onError={(e) => {
              const defaultAvatar = proxy() + "/image/avatar/default-ava.png";
              if (e.target.src !== defaultAvatar) {
                e.target.src = defaultAvatar;
              }
            }}
          />
        </div>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileUpload}
        />
      </div>
      <div className="mt-5 col-lg-8 col-xs-12">
        <div class="mb-3 row">
          <label class="col-sm-4 col-form-label font-weight-bold text-right infor_input">
            {lang["username"]}
            {/* <span className="red_star ml-1">*</span> */}
          </label>
          <div class="col-sm-8">
            <input
              type="text"
              class="form-control"
              readOnly
              {...register("username")}
            />
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-sm-4 col-form-label font-weight-bold text-right infor_input">
            {lang["fullname"]}
            {/* <span className="red_star ml-1">*</span> */}
          </label>
          <div class="col-sm-8">
            <input type="text" class="form-control" {...register("fullname")} />
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-sm-4 col-form-label font-weight-bold text-right infor_input">
            {lang["email"]}
            {/* <span className="red_star ml-1">*</span> */}
          </label>
          <div class="col-sm-8">
            <input type="email" class="form-control" {...register("email")} />
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-sm-4 col-form-label font-weight-bold text-right infor_input">
            {lang["phone"]}
            {/* <span className="red_star ml-1">*</span> */}
          </label>
          <div class="col-sm-8">
            <input type="number" class="form-control" {...register("phone")} />
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-sm-4 col-form-label font-weight-bold text-right infor_input">
            {lang["address"]}
            {/* <span className="red_star ml-1">*</span> */}
          </label>
          <div class="col-sm-8">
            <input type="text" class="form-control" {...register("address")} />
          </div>
        </div>
        <div class="mb-3 row">
          <label class="col-sm-4 col-form-label font-weight-bold text-right infor_input">
            {lang["note"]}
            {/* <span className="red_star ml-1">*</span> */}
          </label>
          <div class="col-sm-8">
            <textarea
              class="form-control"
              {...register("note")}
              rows={5}
            ></textarea>
          </div>
        </div>
        <button type="submit" class="btn btn-success btn-custom float-right">
          {lang["update.config"]}
        </button>
      </div>
    </form>
  );
}
